import { ModuleFE_BaseApi } from '@nu-art/thunderstorm-frontend/index';
import { ThunderDispatcherV3 } from '@nu-art/thunderstorm-frontend/core/db-api-gen/types';
import { DBDef_PermissionDomain } from '@nu-art/permissions-shared';
export const dispatch_onPermissionDomainChanged = new ThunderDispatcherV3('__onPermissionDomainUpdated');
export class ModuleFE_PermissionDomain_Class extends ModuleFE_BaseApi {
    constructor() {
        super(DBDef_PermissionDomain, dispatch_onPermissionDomainChanged);
    }
}
export const ModuleFE_PermissionDomain = new ModuleFE_PermissionDomain_Class();
//# sourceMappingURL=ModuleFE_PermissionDomain.js.map